<template>
  <div class="pricing">
    <PricingHero />
    <Story />
    <Faq />
    <Integrations />
    <Ready />
  </div>
</template>

<script>
import PricingHero from "@/components/PricingHero";
export default {
  components: {
    PricingHero,
    Story: () => import("@/components/Story"),
    Faq: () => import("@/components/Faq"),
    Integrations: () => import("@/components/Integrations"),
    Ready: () => import("@/components/Ready"),
  },
};
</script>
